import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import type { AiCostLimitState } from '@Domain/AiCostLimits/AiCostLimitState';

export type AiCostLimitPayload = {
	readonly id: number;
	readonly level: { readonly value: AiCostLimitLevel; readonly label: string };
	readonly subjectId: number;
	readonly monthlyAmount: number;
	readonly alertThresholdPercent: number;
	readonly status: {
		readonly state: { readonly value: AiCostLimitState; readonly label: string };
		readonly percent: number;
	};
};

export type AiCostLimitsFetchedAction = {
	type: 'AI_COST_LIMITS_FETCHED';
	payload: AiCostLimitPayload[];
	accountId: number;
};

export default (payload: AiCostLimitPayload[], accountId: number): AiCostLimitsFetchedAction => ({
	type: 'AI_COST_LIMITS_FETCHED',
	payload,
	accountId,
});
